<template lang="pug">
    v-card.DropdownsParagraph(v-if="currentStep.question" flat)
      v-card-text.title-para
        | {{currentStep.question.title}}
        ul.list(v-if="currentStep.question.list")
          li(v-for="l in currentStep.question.list") {{l}}
        v-flex(xs12, sm15, md12)
          span.text-para(v-for="(option, index) in currentStep.question.options") {{option.label}}
            span(v-if="currentStep.check")
              v-icon(size='25px' color="green" v-if="option.chosen") check
              v-icon(size='25px' color="red" v-else) close
            v-select.select(:readonly="currentStep.check" :items="option.combos" item-text="name" 
              item-value="valor" label="Selecciona..." 
              @change="checkAnswer(index, $event)"
              solo hide-details=true v-if="option.combos != null" 
              :key="index"
              v-model="option.value")
          span.text-para(v-for="(option, index) in currentStep.question.options") {{option.label2}} 
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'DropdownsParagraph',
  computed: {
    ...mapGetters(['currentStep'])
  }, 
  
  methods: {
    checkAnswer(index, item) {
      let allanswered = 0;
      this.currentStep.question.options[index].chosen = item;

      for(var i=0; i < this.currentStep.question.options.length; i++){
        if((this.currentStep.question.options[i].chosen === true)||(this.currentStep.question.options[i].chosen === false)){
          allanswered++;
        }
      }

      if(allanswered === this.currentStep.question.limit){
        this.currentStep.answered = true;
      }
    },
    changeValue(option) {   
      this.currentStep.answered = true;      
    }
  }
}
</script>

<style scoped>
@import 'dropdowns-paragraph.scss';
</style>
